module.exports = __webpack_public_path__ + "img/background.4c69294c.jpg";